module.exports = __webpack_public_path__ + "static/slack-note-webhook-d81222974c4f5f90266a3f528bd29cb8.png";